import { api } from './api';

export const reportsService = {
    // Month-wise revenue / commission / GST, broken down by vendor.
    // params: { from: 'YYYY-MM', to: 'YYYY-MM', months: number }
    getRevenueReport: (params = {}) => api.get(`/api/admin/reports/revenue${_qs(params)}`),

    // Month-wise vendor SLA (acceptance / arrival / completion / rating / SLA
    // score), broken down by vendor. Same params.
    getVendorSlaReport: (params = {}) => api.get(`/api/admin/reports/vendor-sla${_qs(params)}`),
};

function _qs(params = {}) {
    const q = new URLSearchParams();
    if (params.from) q.set('from', params.from);
    if (params.to) q.set('to', params.to);
    if (params.months) q.set('months', String(params.months));
    const s = q.toString();
    return s ? `?${s}` : '';
}
